import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image — keep existing */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/9f8431f66740650b60a6ba4e6e417a1f.jpg')`
        }}
      />
      {/* Overlay — slightly heavier on left for text clarity */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/20" />

      {/* Content */}
      <div className="relative z-10 w-full px-6 sm:px-10 lg:px-20 max-w-7xl mx-auto py-32">
        <div className="max-w-2xl">

          {/* Location pill */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full mb-6">
            <i className="ri-map-pin-2-fill text-pink-300 text-xs"></i>
            <span className="text-white/90 text-xs font-semibold tracking-widest uppercase">Gwinnett + Surrounding Counties</span>
          </div>

          {/* Headline */}
          <h1 className="mb-6 leading-tight tracking-tight">
            <span className="block text-3xl md:text-4xl font-semibold text-white/80 mb-1 tracking-wide">
              Mix &bull; Mingle
            </span>
            <span className="block text-5xl md:text-6xl lg:text-7xl font-extrabold text-white">
              Make Memories
            </span>
          </h1>

          {/* Subtext */}
          <p className="text-base md:text-lg text-white/80 mb-10 leading-relaxed font-light max-w-xl">
            The Mommy Mingle is a community connecting moms across Gwinnett and surrounding counties.
            <br /><br />
            From events and local finds to real connections and trusted recommendations, this is where moms go when they want better options without the overwhelm.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 mb-12">
            <Link
              to="/events"
              className="inline-flex items-center justify-center gap-2.5 px-8 py-4 bg-pink-600 text-white rounded-full text-sm font-bold hover:bg-pink-500 transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg shadow-pink-900/30"
            >
              <i className="ri-calendar-event-line text-base"></i>
              See What&apos;s Happening This Week
            </Link>
            <a
              href="https://www.facebook.com/groups/themommymingle"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2.5 px-8 py-4 bg-white/15 backdrop-blur-sm border-2 border-white/40 text-white rounded-full text-sm font-bold hover:bg-white/25 hover:border-white/70 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-heart-fill text-base"></i>
              Join The Mommy Mingle
            </a>
          </div>

          {/* Positioning line */}
          <p className="text-white/55 text-xs md:text-sm font-semibold tracking-widest uppercase mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-white/30 inline-block shrink-0" />
            This is where local moms go before they decide.
          </p>

          {/* Social Proof */}
          <div className="flex flex-wrap gap-x-8 gap-y-4">
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-extrabold text-white leading-none">5,000+</span>
              <span className="text-xs text-white/60 font-medium tracking-wide mt-1">Local Moms</span>
            </div>
            <div className="w-px h-10 bg-white/20 self-center hidden sm:block" />
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-extrabold text-white leading-none">150+</span>
              <span className="text-xs text-white/60 font-medium tracking-wide mt-1">Trusted Businesses</span>
            </div>
            <div className="w-px h-10 bg-white/20 self-center hidden sm:block" />
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-extrabold text-white leading-none">200+</span>
              <span className="text-xs text-white/60 font-medium tracking-wide mt-1">Events Hosted</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 opacity-50">
        <div className="w-px h-8 bg-white animate-pulse"></div>
        <i className="ri-arrow-down-s-line text-white text-xl"></i>
      </div>
    </section>
  );
}
